"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cachePatchesKey = void 0;
exports.cachePatchesKey = "cachePatches";
//# sourceMappingURL=types.js.map